function PointOfInterestDataObject() {
    //POI extend
    Zone.call(this);
    this.PoiFlag = 1;
    this.MakePublic = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = PointOfInterestDataObject;
}